import React, { useState } from 'react';
import './AddSiteModal.css';

function AddSiteModal({ onAdd, onClose }) {
  const [name, setName] = useState('');
  const [url, setUrl] = useState('');
  const [iconOption, setIconOption] = useState('placeholder');
  const [iconUrl, setIconUrl] = useState('');
  const [iconPreview, setIconPreview] = useState(null);
  const [iconData, setIconData] = useState(null);

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setIconPreview(reader.result);
        setIconData(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (name.trim() && url.trim()) {
      let icon = 'placeholder';
      if (iconOption === 'upload' && iconData) {
        icon = iconData;
      } else if (iconOption === 'url' && iconUrl) {
        icon = iconUrl;
      }
      
      onAdd({
        name: name.trim(),
        url: url.trim(),
        icon: icon
      });
      setName('');
      setUrl('');
      setIconOption('placeholder');
      setIconUrl('');
      setIconPreview(null);
      setIconData(null);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Add New Site</h2>
          <button className="close-button" onClick={onClose}>×</button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="site-name">Site Name</label>
            <input
              type="text"
              id="site-name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="e.g., Confluence"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="site-url">URL</label>
            <input
              type="url"
              id="site-url"
              value={url}
              onChange={(e) => setUrl(e.target.value)}
              placeholder="https://example.com"
              required
            />
          </div>

          <div className="form-group">
            <label>Site Icon</label>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginBottom: '10px', alignItems: 'flex-start' }}>
              <label style={{ display: 'inline-flex', alignItems: 'center', gap: '10px', cursor: 'pointer', whiteSpace: 'nowrap' }}>
                <input
                  type="radio"
                  name="icon-option"
                  value="placeholder"
                  checked={iconOption === 'placeholder'}
                  onChange={(e) => setIconOption(e.target.value)}
                />
                Use placeholder (first letter)
              </label>
              <label style={{ display: 'inline-flex', alignItems: 'center', gap: '10px', cursor: 'pointer', whiteSpace: 'nowrap' }}>
                <input
                  type="radio"
                  name="icon-option"
                  value="url"
                  checked={iconOption === 'url'}
                  onChange={(e) => setIconOption(e.target.value)}
                />
                Image URL
              </label>
              <label style={{ display: 'inline-flex', alignItems: 'center', gap: '10px', cursor: 'pointer', whiteSpace: 'nowrap' }}>
                <input
                  type="radio"
                  name="icon-option"
                  value="upload"
                  checked={iconOption === 'upload'}
                  onChange={(e) => setIconOption(e.target.value)}
                />
                Upload image file
              </label>
            </div>
            
            {iconOption === 'url' && (
              <input
                type="url"
                id="icon-url"
                value={iconUrl}
                onChange={(e) => setIconUrl(e.target.value)}
                placeholder="e.g., https://example.com/logo.png"
              />
            )}
            
            {iconOption === 'upload' && (
              <>
                <input
                  type="file"
                  id="site-icon"
                  accept="image/*"
                  onChange={handleImageUpload}
                  className="file-input"
                />
                {iconPreview && (
                  <div className="image-preview">
                    <img src={iconPreview} alt="Icon preview" />
                  </div>
                )}
              </>
            )}
          </div>

          <div className="modal-actions">
            <button type="button" onClick={onClose} className="cancel-button">
              Cancel
            </button>
            <button type="submit" className="submit-button">
              Add Site
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddSiteModal;
